// extracted by mini-css-extract-plugin
export default {"photos":"style_photos__c71YK","photos__gallery":"style_photos__gallery__3029e"};